import type { QuizQuestionMedia } from '../../types';
import { resolveQuizMediaUrl } from '../../lib/quiz-media';
import { cn } from '../../lib/utils';

const frameClass =
  'rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-surface-1)] overflow-hidden mb-4';

export function QuizQuestionMediaView({ media }: { media: QuizQuestionMedia | null | undefined }) {
  if (!media) return null;

  const src = resolveQuizMediaUrl(media);

  if (media.kind === 'image') {
    return (
      <div className={cn(frameClass, 'p-2')}>
        <img
          src={src}
          alt=""
          className="mx-auto block w-full max-h-40 object-contain"
          loading="lazy"
        />
      </div>
    );
  }

  if (media.kind === 'audio') {
    return (
      <div className={cn(frameClass, 'px-3 py-2')}>
        <audio
          controls
          preload="metadata"
          className="block w-full h-9 accent-[var(--color-accent)]"
        >
          <source src={src} />
        </audio>
      </div>
    );
  }

  return (
    <div className={frameClass}>
      <video
        controls
        preload="metadata"
        playsInline
        className="block w-full max-h-48 bg-[var(--color-surface-2)]"
      >
        <source src={src} />
      </video>
    </div>
  );
}
